import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { firebaseAuth, pythonApiIp, logComponentLoad, serverIp } from '../../../../config/constants.js'
import { checkAdminEmail, getPrintValues } from '../algoliaDashboard/AlgoliaMiscUtils';
import * as UiConsts from '../../../../config/UiConstants';
import axios from 'axios'
import { Card, Icon, Grid} from 'semantic-ui-react';
import ClosePayNowProjects from '../LargeProjects/ClosePayNowProjects'

function TeamLinksItem(props) {

    // const menuItem = props.orderSize > 0
    //   ? <Menu.Item name={props.name} onClick={props.handleItemClick}>
    //     <Label color={props.color}>{props.orderSize}</Label>
    //     {props.menuText}
    //   </Menu.Item>
    //   : ''

    const linkObject = () => (
        <Card>
            <Card.Content header='About Amy' />
            <Card.Content description={"rock"} />
            <Card.Content extra>
                <Icon name='user' />4 Friends
            </Card.Content>
        </Card>
    )

    return (
        <div>
            {linkObject}
        </div>
    )
}

class TeamLinksDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            algoliaUser: '',
            teamLinkObjects: []
        }
    }

    componentDidMount() {


        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");

            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }

        })
    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "TeamLinksDashboard");

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })

        getPrintValues("teamLinks", this.fromWhere);
    }

    fromWhere = (statuses) => {
        console.log("ddx12 ++++++ loadStatuses ");
        console.log("ddx121 statuses:" + JSON.stringify(statuses, null, 3));
        this.setState({ teamLinkObjects: statuses })
    }

    render() {

        const userEmail = this.state.user && this.state.user.email
            ? <h3>{this.state.user.email}</h3>
            : 'no email'

        const uploadDocument = this.state.user && this.state.user.email && this.state.user.email == 'ivanmworozi@gmail.com'
            ? <h1>Upload Document - <Link to={'/dashboard/addDocument'}>Add Document (ivan only)</Link></h1>
            : 'no email'

        const closePayNowUI = this.state.user && this.state.user.email
            ? <ClosePayNowProjects user={this.state.user} />
            : ''

        // const dailyExpenses = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.dailyExpenses
        //     ? <h1>Daily Expenses - <Link to={'/dashboard/dailyExpenses'}>dailyExpenses REGULAR</Link></h1>
        //     : ''

        const paymentsPage = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.paymentsPage
            ? <h1>paymentsPage - <Link to={'/dashboard/paymentsPage'}>paymentsPage</Link></h1>
            : ""

        const receipList = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("receiptList")
            ? <h1>Search <Link to={'/dashboard/receipList'}>receiptList</Link></h1>
            : ""

        const dailyExpenses = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.dailyExpenses
            ? <h1>Upload Daily Expense - <Link to={'/dashboard/dailyExpenses'}>Upload Daily Expense Single items</Link></h1>
            : ''

        const expensesUpload = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.expensesUpload
            ? <h1>Upload Expense List - <Link to={'/dashboard/expensesUpload'}>Upload Daily Expense File</Link></h1>
            : ''

        // const suppliesList = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("sendSuppliesList")
        //     ? <h1>Supplies List - <Link to={'/suppliesList'}>Supplies List</Link></h1>
        //     : ''


        // const WhatsappRejectedChatView = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("WhatsappRejectedChatView")
        //     ? <h1> Whatsapp Rejected Chats - <Link to={'/dashboard/WhatsappRejectedChatView'}>Whatsapp Rejected Chats</Link></h1>
        //     : ''

        // const WhatsappMainChatView = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("WhatsappMainChatView")
        //     ? <h1> Whatsapp Main Chat View - <Link to={'/dashboard/chatView'}>Whatsapp Main Chat View </Link></h1>
        //     : ''

        // const password_reset = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("password_reset")
        //     ? <h1> Password Reset- <Link to={'/dashboard/passwordReset'}>passwordReset </Link></h1>
        //     : ''

        // const enterReciept = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("enterReceipts")
        //     ? <h1> enterReciept- <Link to={'/dashboard/enterReciept'}>enterReciept </Link></h1>
        //     : ''

        // const submitRequisition = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.isAdmin && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("SubmitRequisition")
        //     ? <h1> Submit Requisition - <Link to={'/dashboard/submitRequisition'}>Submit Requisition </Link></h1>
        //     : ''

        // const paymentAdvance = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.isAdmin && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("paymentAdvance")
        //     ? <h1> Pay Advance - <Link to={'/dashboard/paymentAdvance'}>paymentAdvance </Link></h1>
        //     : ''


        // const fabricPayment = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.isAdmin && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("enterFabricPayment")
        //     ? <h1> Enter Fabric Payment - <Link to={'/dashboard/enterFabricPayment'}>enterFabricPayment </Link></h1>
        //     : ''

        // const enterUnknowDeposit = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.isAdmin && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("enterUnknowDeposit")
        //     ? <h1> Ask About Unkown Deposit - <Link to={'/dashboard/enterUnknowDeposit'}>Ask About Unkown Deposit </Link></h1>
        //     : ''

        // const enterAworiLog = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.enterAworiLog
        //     ? <h1>ENTER ACC DEP / DEDUCTIONS - <Link to={'/dashboard/enterAworiLog'}>ENTER ACC DEP / DEDUCTIONS</Link></h1>
        //     : ''

        // const pbAccountAccessLog = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("pb_account_acc")
        //     ? <h1>REQUEST ACCCESS TO PB ACC - <Link to={'/dashboard/pbAccountAccessLog'}> REQUEST ACCCESS TO PB ACC</Link></h1>
        //     : ''

        // const payAllowances = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("payAllowances")
        //     ? <h1> payAllowances- <Link to={'/dashboard/payAllowances'}> payAllowances</Link></h1>
        //     : ''

        // const enterExpense = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("DailyExpenses_ivan")
        //     ? <h1> enter Expense - <Link to={'/dashboard/dailyExpenses_ivan'}> Enter Expense</Link></h1>
        //     : ''

        // const viewRecentVinylPayments = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("ViewRecentVinylPayments")
        //     ? <h1> View Recent Vinyl Payments - <Link to={'/dashboard/viewRecentVinylPayments'}> View Recent Vinyl Payments</Link></h1>
        //     : ''

        // const report_deposits_this_month = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("report_deposits_this_month")
        //     ? <h1> View Deposits This Month - <a href='https://datastudio.google.com/u/0/reporting/35b0ae03-9aa5-4129-b590-ad64ff32afd2/page/0kyUC' target="_blank">View Deposits This Month</a> </h1>
        //     : ''

        // const linksMap = this.state.teamLinkObjects.length > 0
        //     ? this.state.teamLinkObjects.map((linkObject) =>
        //         <TeamLinksItem linkObject={linkObject} />
        //     )
        //     : <h4>NO LINK OBJECTS</h4>

        const linksMap = this.state.algoliaUser != '' && this.state.teamLinkObjects.length > 0
            ? this.state.teamLinkObjects.map((linkObject) =>
                //linkObject.description == 'Upload Daily Expense'
                this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes(linkObject.permission)
                    ?
                    <Grid.Column>
                        <Card>
                            <Card.Content header={linkObject.linkBody} />
                            <Card.Content href={linkObject.link} />
                            <Card.Content description={linkObject.description} />
                            <Card.Content meta={linkObject.permission} />
                            <Card.Content extra>
                                <Link to={linkObject.link} >OPEN</Link>
                            </Card.Content>
                        </Card>
                    </Grid.Column>

                    : <h4>NOT ALLOWED {linkObject.permission}</h4>)



            : <h4>NO LINK OBJECTS</h4>

        const wholeUI = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.isAdmin
            ? <div>
                <h1>Links Dashboard </h1>
                <Grid stackable columns={3}>
                    {linksMap}
                </Grid>



                {/* {dailyExpenses}
                {paymentsPage} */}
                {/* {receipList} */}
                {/* {dailyExpenses} */}
                {/* {expensesUpload} */}
                {/* {suppliesList}
                {WhatsappRejectedChatView}
                {WhatsappMainChatView} */}
                {/* {enterReciept} */}
                {/* {password_reset} */}
                {/* {submitRequisition}
                {paymentAdvance}
                {fabricPayment}
                {enterUnknowDeposit}
                {enterAworiLog} */}
                {/* {pbAccountAccessLog} */}
                {/* {payAllowances}
                {enterExpense}
                {viewRecentVinylPayments} */}
                {/* {report_deposits_this_month} */}

            </div>
            : <div><h2>YOU ARE NOT AN AUTHORIZED</h2>{userEmail}</div>

        return (this.state.loading ? <UiConsts.LoadingComponent /> : <div>

            {wholeUI}

        </div>);
    }
}

export default TeamLinksDashboard;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Billing/TeamLinksDashboard.js